import { tannerGray } from '../ThemeProvider/colors';
import styled from '@emotion/styled';

export const IconWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'focused',
})<{ focused?: boolean; width: number; height: number; fontSize: number; margin: string }>(
  ({ focused, width, height, fontSize, margin }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    color: focused ? tannerGray[300] : tannerGray['500'],
    width,
    height,
    fontSize,
    margin,
    borderRadius: '50%',
    boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.25)',
    transition: 'color 0.2s',
  })
);
